import React from "react";

export function plan1() {
  return (
    <svg width="217" height="131" viewBox="0 0 217 131" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.847331" y="1.31462" width="215.583" height="128.917" rx="5.95833" fill="#E1EDFA" stroke="#A0D2F6" strokeWidth="1.08333" />
      <line x1="0.305664" y1="13.8121" x2="216.972" y2="13.8121" stroke="#B2D8FF" strokeWidth="1.08333" />
      <circle cx="7.55117" cy="7.67275" r="2.44375" fill="#C6E3FF" />
      <circle cx="14.7221" cy="7.67275" r="2.44375" fill="#C6E3FF" />
      <circle cx="21.892" cy="7.67275" r="2.44375" fill="#C6E3FF" />
      <rect x="7.55078" y="21.0616" width="50.2775" height="103.131" rx="6.5" fill="#B2D8FF" />
      <rect x="62.1631" y="21.0616" width="71.1378" height="35.1113" rx="6.5" fill="#B2D8FF" />
      <rect x="62.1631" y="87.4225" width="144.352" height="35.1113" rx="6.5" fill="#B2D8FF" />
      <rect x="137.652" y="21.0616" width="71.1378" height="35.1113" rx="6.5" fill="#B2D8FF" />
      <rect x="64.4385" y="60.9646" width="68.8623" height="4.33333" rx="2.16667" fill="#C6E3FF" />
      <rect x="64.4385" y="69.6312" width="57.1339" height="4.33333" rx="2.16667" fill="#C6E3FF" />
      <rect x="64.4385" y="78.298" width="45.9859" height="4.33333" rx="2.16667" fill="#C6E3FF" />
      <rect x="137.652" y="60.9646" width="68.8623" height="4.33333" rx="2.16667" fill="#C6E3FF" />
      <rect x="137.652" y="69.6312" width="57.1339" height="4.33333" rx="2.16667" fill="#C6E3FF" />
      <rect x="137.652" y="78.298" width="45.9859" height="4.33333" rx="2.16667" fill="#C6E3FF" />
      <rect x="92.7471" y="5.1676" width="31.7845" height="3.67146" rx="1.83573" fill="#9EC5EB" />
    </svg>
  );
}
